var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestorWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 398,
    height: 95.636,
    viewBox: "0 0 398 95.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M0,61.579H398V-34.057H0Z",
    transform: "translate(0 34.057)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 34.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 -34.057)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2",
    "data-name": "Group 5",
    transform: "translate(-0.001 12.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M2.2,8.9A26.449,26.449,0,0,1,11.32-1.256,22.545,22.545,0,0,1,23.757-4.923q9.713,0,15.066,6.144v-5.65H58.247V77.728H38.823v-33.1a19.138,19.138,0,0,1-15.164,7.237A22.983,22.983,0,0,1,11.222,48.3a25.371,25.371,0,0,1-9.07-10.011,31.157,31.157,0,0,1-3.37-14.667A31.1,31.1,0,0,1,2.2,8.9m33.5,5.948a9.98,9.98,0,0,0-6.987-2.923,9.817,9.817,0,0,0-6.987,3.022Q18.6,17.972,18.6,23.619t3.072,8.475a10.1,10.1,0,0,0,7.037,2.822A9.891,9.891,0,0,0,35.7,31.945q3.121-2.974,3.123-8.624,0-5.547-3.123-8.472",
    transform: "translate(1.218 4.923)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(70.165 13.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M36.884,0V55.6H17.359V47.671a18.32,18.32,0,0,1-6.838,6.094A20.91,20.91,0,0,1,.513,56.092Q-9.2,56.092-14.8,49.7T-20.4,32.31V0H-1.074V29.831a10.565,10.565,0,0,0,2.527,7.481,8.681,8.681,0,0,0,6.689,2.727,8.644,8.644,0,0,0,6.739-2.727,10.7,10.7,0,0,0,2.477-7.481V0Z",
    transform: "translate(20.399)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(135.376 12.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M36.054,20.867H-.716q.3,4.558,2.527,6.79a7.726,7.726,0,0,0,5.7,2.23,7.139,7.139,0,0,0,6.936-4.361H35.161a24.256,24.256,0,0,1-5,10.258,25.822,25.822,0,0,1-9.365,7.085A29.731,29.731,0,0,1,8.3,45.447,30.148,30.148,0,0,1-6.315,41.976a24.882,24.882,0,0,1-10.008-9.91A30.458,30.458,0,0,1-19.94,16.9,30.539,30.539,0,0,1-16.374,1.789a24.7,24.7,0,0,1,9.96-9.862A30.391,30.391,0,0,1,8.3-11.541a30.614,30.614,0,0,1,14.569,3.37,24.284,24.284,0,0,1,9.91,9.663A29.556,29.556,0,0,1,36.352,16.31a35.486,35.486,0,0,1-.3,4.558M16.529,11.452a6.967,6.967,0,0,0-2.378-5.6A8.819,8.819,0,0,0,8.206,3.822,8.722,8.722,0,0,0,2.359,5.754a9.391,9.391,0,0,0-2.974,5.7Z",
    transform: "translate(19.94 11.541)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(196.722 12.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M8.455,35.065A22.917,22.917,0,0,1-.863,28.126a18.012,18.012,0,0,1-3.813-9.96H14.152a5.964,5.964,0,0,0,2.48,4.164,8.631,8.631,0,0,0,5.153,1.485,6.358,6.358,0,0,0,3.766-.991,3.036,3.036,0,0,0,1.387-2.578,3.248,3.248,0,0,0-2.28-3.069A46.951,46.951,0,0,0,17.126,15a64.947,64.947,0,0,1-9.91-2.676A16.871,16.871,0,0,1,.328,7.464Q-2.6,4.094-2.6-1.654A15.822,15.822,0,0,1,.081-10.623a18.272,18.272,0,0,1,7.88-6.391A29.976,29.976,0,0,1,20.5-19.393q10.9,0,17.146,5.352A20.919,20.919,0,0,1,44.876.031H27.334a6.522,6.522,0,0,0-2.328-4.114A7.746,7.746,0,0,0,20.1-5.518a6.144,6.144,0,0,0-3.617.89,2.877,2.877,0,0,0-1.238,2.477A3.283,3.283,0,0,0,17.522.873,38.866,38.866,0,0,0,24.857,3,64.924,64.924,0,0,1,34.916,5.877a17.9,17.9,0,0,1,7.037,5.105q3.02,3.517,3.022,9.562a14.406,14.406,0,0,1-2.825,8.722,18.809,18.809,0,0,1-8.026,6.094,30.887,30.887,0,0,1-12.241,2.232A33.8,33.8,0,0,1,8.455,35.065",
    transform: "translate(4.676 19.393)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(252.12 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M23.547,33.821V50.372H15.123q-21.309,0-21.305-21.109V10.929h-6.841V-5.226h6.841V-18.705H13.34V-5.226H23.449V10.929H13.34V29.558a4.363,4.363,0,0,0,1.042,3.271,5.016,5.016,0,0,0,3.516.991Z",
    transform: "translate(13.023 18.705)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(294.438 12.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M9.093,34.459a25.553,25.553,0,0,1-10.356-9.91A29.5,29.5,0,0,1-5.029,9.385,29,29,0,0,1-1.213-5.677a25.892,25.892,0,0,1,10.4-9.913,31.554,31.554,0,0,1,14.917-3.468A31.551,31.551,0,0,1,39.022-15.59,25.917,25.917,0,0,1,49.429-5.677,29,29,0,0,1,53.245,9.385,29.267,29.267,0,0,1,49.429,24.5a25.7,25.7,0,0,1-10.455,9.96A31.819,31.819,0,0,1,24.01,37.927,31.521,31.521,0,0,1,9.093,34.459m21.7-16.4q2.725-3.02,2.727-8.671T30.8.764a8.722,8.722,0,0,0-6.689-2.974A8.578,8.578,0,0,0,17.467.764q-2.675,2.97-2.676,8.621,0,5.75,2.578,8.722a8.393,8.393,0,0,0,6.641,2.974A8.764,8.764,0,0,0,30.8,18.057",
    transform: "translate(5.029 19.058)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(360.637 12.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M17.613,1.786A19.217,19.217,0,0,1,27.621-.988V19.725H22.17q-6.344,0-9.413,2.477T9.686,30.825V55.1H-9.741V-.494H9.686V9.318a25.278,25.278,0,0,1,7.927-7.531",
    transform: "translate(9.741 0.988)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestorWhiteLogo);
export default __webpack_public_path__ + "static/media/questor-white-logo.20a4f342.svg";
export { ForwardRef as ReactComponent };